"use client";

import { useCallback } from "react";

import { useResetPatientClaim } from "@/hooks/patient-claim/use-patient-claim";

import { authService } from "@/services/auth-service";

/**
 * Sign-out helper for patient-claim surfaces (self-schedule, forms, pay,
 * shop). Signs out of Firebase, clears the patient-claim cache, then runs
 * an optional caller-supplied side effect (e.g. router redirect).
 */
export function useSignOutPatient(onAfterSignOut?: () => void) {
  const resetPatientClaim = useResetPatientClaim();
  return useCallback(async () => {
    try {
      await authService.logout();
    } catch {
      // Logout failed; clear local state anyway.
    }
    resetPatientClaim();
    onAfterSignOut?.();
  }, [resetPatientClaim, onAfterSignOut]);
}
